<template>
  <div>
    <q-table
      dense
      :data="pesquisas"
      :grid="false"
      :columns="columns"
    >
      <template v-slot:top-right>
        <q-btn
          color="primary"
          dense
          flat
          icon="add"
          label="Nova pesquisa"
          @click="dialogNovaPesquisa = true"
        />
      </template>
      <template v-slot:body-cell-editar="props">
        <q-td>
          <q-btn flat size="sm" dense icon="more_vert" round>
            <q-menu>
              <q-list style="min-width: 100px" dense>
                <q-item clickable v-close-popup @click="selectPesquisa(props.row)">
                  <q-item-section avatar>
                    <q-icon name="edit" color="primary" />
                  </q-item-section>
                  <q-item-section>Editar</q-item-section>
                </q-item>
                <q-item clickable v-close-popup @click="openDialogResultados(props.row._id)">
                  <q-item-section avatar>
                    <q-icon name="bar_chart" color="primary" />
                  </q-item-section>
                  <q-item-section>Resultados</q-item-section>
                </q-item>
              </q-list>
            </q-menu>
          </q-btn>
          <!-- <q-btn @click="selectPesquisa(props.row)" color="primary" icon="edit" size="sm" dense flat round /> -->
        </q-td>
      </template>
    </q-table>
    <q-dialog v-if="dialogNovaPesquisa" :value="true" persistent maximized>
      <q-card>
        <q-card-section class="row items-center q-pa-sm bg-primary text-white">
          <div class="text-h6">Criar nova pesquisa</div>
          <q-space />
          <q-btn icon="close" flat round dense @click="closeDialog" />
        </q-card-section>
        <q-card-section>
          <FormPesquisa @on-save="onSavePesquisa" :pesquisaSelecionada="pesquisaSelecionada" />
        </q-card-section>
      </q-card>
    </q-dialog>
    <Resultados :idPesquisa="idPesquisaSelecionada" ref="resultados" />
  </div>
</template>

<script>
import FormPesquisa from './FormPesquisa'
import Resultados from './Resultados'
import { getPesquisas } from '../../services/pesquisa'
import moment from 'moment'

export default {
  data () {
    return {
      pesquisaSelecionada: {},
      idPesquisaSelecionada: '',
      dialogNovaPesquisa: false,
      pesquisas: [],
      loading: false,
      columns: [
        { name: 'nome', field: 'nome', label: 'Nome', align: 'left' },
        { name: 'criadoEm', field: 'criadoEm', label: 'Criada Em', align: 'left', format: value => moment(value).format('DD/MM/YYYY') },
        { name: 'validade', field: 'validade', label: 'Validade', align: 'left', format: value => moment(value).format('DD/MM/YYYY') },
        { name: 'usuario', field: row => row.usuario.nome, label: 'Usuário', align: 'left' },
        { name: 'editar', field: 'editar', label: 'Opções', align: 'left' },
        // { name: 'cpf', field: 'cpf', label: 'CPF', align: 'left', format: value => formatCpfCnpj(value) },
      ]
    }
  },
  mounted () {
    this.getPesquisas()
  },
  methods: {
    async getPesquisas () {
      try {
        this.loading = true
        this.pesquisas = await getPesquisas()
      } catch (error) {
        console.error(error)
        this.$q.notify({
          color: 'red',
          position: 'top-right',
          icon: 'report_problem',
          message: 'Não foi possível buscar as pesquisas no momento. Tente daqui a pouco.'
        })
      } finally {
        this.loading = false
      }
    },

    onSavePesquisa () {
      this.getPesquisas()
      this.dialogNovaPesquisa = false
      this.pesquisaSelecionada = {}
    },

    closeDialog () {
      this.dialogNovaPesquisa = false
      this.pesquisaSelecionada = {}
    },

    selectPesquisa (pesquisa) {
      this.pesquisaSelecionada = pesquisa
      this.dialogNovaPesquisa = true
    },

    openDialogResultados (idPesquisa) {
      this.idPesquisaSelecionada = idPesquisa
      setTimeout(() => {
        this.$refs.resultados.open()
      }, 50);
    }
  },

  components: {
    FormPesquisa,
    Resultados
  }
}
</script>